<template>
  <div class="p-4 space-y-3">
    <div class="flex gap-1.5">
      <BenchmarkIcon class="text-icon-muted" />
      <BaseText type="label" size="sm" class="text-text-muted">
        Benchmarks
      </BaseText>
      <BaseText size="sm" class="text-text-normal capitalize">
        {{ benchmarkCopy }}
      </BaseText>
    </div>
    <div class="flex flex-wrap gap-y-3 mt-3">
      <div v-for="benchmark in benchmarkStats" :key="benchmark.metricKey"
      class="grid grid-cols-12 w-full place-items-center justify-items-start"
      style="max-width: 50%">
        <BaseText class="w-1/4 text-text-normal uppercase col-span-3" size="sm">
          {{ benchmark.metricKey }}
        </BaseText>
        <div class="col-span-2 justify-self-end mr-2">
          <BaseText class="text-text-subdued text-left" size="sm">
            {{ getIsPrivateMode ? '•••' : benchmark.avg }}
          </BaseText>
        </div>
        <div class="col-span-2">
          <BaseText type="label" size="sm" :class="benchmark.textColor">
            {{ getIsPrivateMode ? '•••' : benchmark.val }}
          </BaseText>
        </div>
        <div v-show="benchmark.val" class="col-span-3">
          <PercentageChangeSlider
            :value="benchmark.percentDiff"
            :isReverse="benchmark.dir === -1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumberLabel} from "../../utils/lens/formatNumberLabel"
import { mapGetters } from 'vuex'
// Components
import PercentageChangeSlider from "./PercentageChangeSlider.vue"
// Icons
import BenchmarkIcon from "../../components/globals/Icons/LensIcons/BenchmarkIcon.vue"

export default{
  name: 'LensBenchmarkCard',
  components: {
    PercentageChangeSlider,
    BenchmarkIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    currencyRegion: {
      type: String,
      default: 'USD'
    }
  },
  data(){
    const BENCHMARK_KEYS = [{key:'cpa', dir: -1}, {key:'cpm', dir: -1}, {key:'cvr', dir: 1}, {key:'roas', dir:1}, {key:'cpc', dir: -1}]
    return {
      BENCHMARK_KEYS
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricLookup']),
    ...mapGetters('MiscModule', ['getIsPrivateMode']),
    benchmarkCopy(){
      const gmv = this.data?.gmv ? (this.data.gmv >= 1000000
        ? `${(this.data.gmv / 1000000).toFixed(0).replace(/\.0$/, '')}M`
        : `${(this.data.gmv / 1000).toFixed(0).replace(/\.0$/, '')}K`)
        : ''
      const aov = this.data?.aov_min || null
      const niche = this.data?.niche ? `${this.data.niche.replace(/_/g, ' ')}` : ''
      const showAov = aov && !this.getIsPrivateMode
      const showGmv = gmv && !this.getIsPrivateMode

      const aovText = showAov ? `>$${aov} AOV` : ''
      const gmvText = showGmv ? `>$${gmv} GMV` : ''

      return `${niche}${showAov ? ', ' : ''} ${aovText}${showGmv ? ', ' : ''} ${gmvText}`
    },
    benchmarkStats(){
      const benchmarkData = this.data
      return this.BENCHMARK_KEYS.map((bench) => {
        const {key, dir} = bench;
        const formattedKey = `channel_reported_${key}`
        const benchData = benchmarkData.benchmarks

        const metricVal = benchmarkData.insights?.[key]
        const metricAvg = benchData?.avg?.[formattedKey]
        const valDiff = ((metricVal - metricAvg) / metricAvg) * 100

        const textCond = dir === 1 ? valDiff < 0 : valDiff > 0
        const textColor = textCond ? 'text-text-muted' : 'text-secondary-green-200'
        
        const formattedValue = formatNumberLabel(benchmarkData.insights?.[key], this.getMetricLookup?.[key]?.type, this.data?.currency)
        const formattedAvg = formatNumberLabel(benchData?.avg?.[formattedKey], this.getMetricLookup?.[key]?.type, this.data?.currency)
          return {
          metricKey: key,
          val: formattedValue,
          avg: formattedAvg,
          percentDiff: valDiff,
          dir,
          textColor
        }
      })
    }
  },
}
</script>